import { Box } from '@mui/material';
import { HeroSection } from '@/components/landing/HeroSection';
import { SocialProofBar } from '@/components/landing/SocialProofBar';
import { FeaturesSection } from '@/components/landing/FeaturesSection';
import { ComplianceSection } from '@/components/landing/ComplianceSection';
import { HowItWorksSection } from '@/components/landing/HowItWorksSection';
import { PricingSection } from '@/components/landing/PricingSection';
import { TestimonialsSection } from '@/components/landing/TestimonialsSection';
import { CtaBanner } from '@/components/landing/CtaBanner';

export function LandingPage() {
  return (
    <Box sx={{ bgcolor: '#050510' }}>
      <HeroSection />
      <SocialProofBar />
      <FeaturesSection />
      <ComplianceSection />
      <HowItWorksSection />
      <PricingSection />
      <TestimonialsSection />
      <CtaBanner />
    </Box>
  );
}
